module.exports = __webpack_public_path__ + "img/text-logo.b9d5f0fa.svg";